import {
  AddIcon,
  IconMenuTrigger,
  Menu,
  MenuContent,
  MenuItem,
  MenuGroup,
  Tooltip,
} from '@packages/systems/spring';
import * as React from 'react';
import type {AvailableOption} from '@packages/systems/designer/forms/types';

export interface OptionsMenuProps {
  options: AvailableOption[];
  isOpen?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  onTooltipOpen: (label: string) => void;
}

export const OptionsMenu = ({
  options,
  isOpen,
  onClose,
  onOpen,
  onTooltipOpen,
}: OptionsMenuProps) => {
  const [tooltipOpen, setTooltipOpen] = React.useState(false);
  const toggleOpen = (next: boolean) => setTooltipOpen(next);

  return (
    <Menu
      placement="bottom-end"
      isOpen={isOpen}
      onRequestClose={onClose}
      onRequestOpen={onOpen}
      width="228px"
      verticalItemAlignment="center"
      shouldCloseOnClickItem
    >
      <IconMenuTrigger
        Icon={AddIcon}
        label="Add Send To Option"
        variant="ghost"
      />
      <MenuContent data-automation-id="send-to-options-menu">
        <MenuGroup>
          {options.map((option) => (
            <Tooltip
              key={option.id}
              label={option.disabledOptionText}
              isDisabled={!option.isDisabled}
              placement="right"
              isOpen={tooltipOpen}
              onOpenChange={(open) => {
                toggleOpen(open);
                if (open) {
                  onTooltipOpen(option?.label);
                }
              }}
              asChild
            >
              <MenuItem
                key={option.id}
                prefix={option.iconComponent}
                onClick={option.onSelect}
                disabled={option.isDisabled}
              >
                {option.label}
              </MenuItem>
            </Tooltip>
          ))}
        </MenuGroup>
      </MenuContent>
    </Menu>
  );
};
